import { Component, OnInit, OnDestroy, Renderer2, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AuthenticationService } from 'app/services/auth.service';
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { NgClass } from '@angular/common';
import { AwardsComponent } from '../../components/Controls/awards/awards.component';

@Component({
    selector: 'client-error',
    templateUrl: 'client-error.component.html',
    imports: [MenuComponent, NgClass, RouterLink, AwardsComponent]
})

export class ClientErrorComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private auth = inject(AuthenticationService);
  private renderer = inject(Renderer2);

  public error?: string;

  public titles: Record<string, string> = {
    '1': 'Please Contact Us',
    '2': 'URL Expired',
    '3': 'Your password needs a reset',
    '4': 'Your account setup is incomplete',
    '5': 'Your account setup is incomplete',
    '6': 'Which username are you looking for?',
    '7': 'Scheduled Maintenance',
    '8': 'Page Not Found',
    '9': 'Something went wrong',
    '10': 'Please Update Your Browser',
    'passwordChanged': 'Your Password has changed.'
  }
  supportEmail = "clientservices@nicolawealth.com";

  constructor(){
    this.renderer.addClass(document.body, 'img_bg');
  }

  ngOnInit() : void {
    this.error = this.route.snapshot.params['code'];
    if (!this.error) this.error = '8';
    if ( ['1','8','9','passwordChanged'].includes(this.error) ) {
      this.auth.logUserOut();
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'img_bg');
  }
}
